import { render } from "./SurveyCreate.vue?vue&type=template&id=47d61639&scoped=true"
import script from "./SurveyCreate.vue?vue&type=script&lang=js"
export * from "./SurveyCreate.vue?vue&type=script&lang=js"

import "./SurveyCreate.vue?vue&type=style&index=0&id=47d61639&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d61639"]])

export default __exports__